<tt-page>
    <tt-select-project style="max-width: 60rem" [params]="params" (submit)="onSubmit($event)"></tt-select-project>
</tt-page>
